import styled, { css } from 'styled-components';
import ActionButton from '../ActionButton';

export default {
  Button: styled(ActionButton)<any>`
    position: absolute;
    z-index: 3;
    cursor: pointer;

    ${({ offset, theme: { isMobile, isRtl } }) =>
      isMobile
        ? css`
            left: ${isRtl ? '8px' : 'auto'};
            right: ${isRtl ? 'auto' : '8px'};
            bottom: ${offset + 8}px;
          `
        : css`
            left: ${isRtl ? '76px' : 'auto'};
            right: ${isRtl ? 'auto' : '76px'};
            bottom: ${offset + 24}px;

            @media (max-width: 1024px) {
              left: ${isRtl ? '68px' : 'auto'};
              right: ${isRtl ? 'auto' : '68px'};
              bottom: ${offset + 8}px;
            }
          `};
  `,

  Inner: styled.div`
    font-size: 16px;
    color: #000;
    padding: 0 16px;
  `,
};
